import { cn } from "@/lib/utils";
import React from "react"

export function GenderToggle ({
  value,
  disabled,
  onChange
}: {
  value?: string,
  disabled?: boolean
  onChange?: any
}) {

  return (

    <div className={cn(
      'gender',
      'input',
      'input-bordered',
      'text-sm',
      'flex',
      'items-center', "flex items-center space-x-2", disabled ? "gender__disabled" : "")}>
      <div>남자</div>
      <input
        type="radio"
        name="gender"
        value="m"
        checked={value === "m"}
        disabled={disabled}
        className={`join-item btn ${value === "m" ? "btn-active" : ""}`}
        onChange={() => onChange("m")}
      />
      <div>여자</div>
      <input
        type="radio"
        name="gender"
        value="f"
        checked={value === "f"}
        disabled={disabled}
        className={`join-item btn ${value === "f" ? "btn-active" : ""}`}
        onChange={() => {
          onChange("f")
        }}
      />
    </div>

  );
}
